import { create } from 'zustand';

export interface ActiveUpload {
  uploadId: string;
  videoId: string;
  fileName: string;
  progress: number; // 0..100
  status: 'uploading' | 'paused' | 'processing' | 'ready' | 'failed';
  bytesUploaded: number;
  bytesTotal: number;
}

interface UploadState {
  active: ActiveUpload | null;
  setActive: (u: ActiveUpload | null) => void;
  updateProgress: (patch: Partial<ActiveUpload>) => void;
}

// Background upload mirror. The actual tus.Upload instance lives in the
// upload route's ref (not serialisable); this store carries display state so
// a persistent banner can show progress from anywhere in the app.
export const useUploadStore = create<UploadState>((set) => ({
  active: null,
  setActive: (active) => set({ active }),
  updateProgress: (patch) => set((s) => (s.active ? { active: { ...s.active, ...patch } } : s)),
}));
